import * as React from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import { IFilterOption } from "../../Utils/Interfaces/IFilter";
import TableContext from "../../TableContext";
import { useContext } from "react";
import queryFilters from "../../../../api/bookings/filter/filterBookings";
import { Button } from "@mui/material";
import "./FilterChip.scss";

interface ChipData {
  key: number;
  label: string;
  name: string;
}

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));
const createChip = (filter: IFilterOption, key: number): ChipData => {
  return {
    key: key,
    label: filter.column + " : " + filter.label,
    name: filter.name,
  };
};

export default function ChipsArray() {
  const tableContextState = useContext(TableContext);
  const tableContext = tableContextState?.tableContext;
  const filters = tableContext ? tableContext.filters : null;

  const [chipData, setChipData] = React.useState<ChipData[]>([]);

  React.useEffect(() => {
    const chips: ChipData[] = [];
    if (filters && filters.length > 0) {
      queryFilters(filters);
      filters.forEach((filter, index) => {
        if (filter.value || filter.showChipEvenFalse)
          chips.push(createChip(filter, index));
      });
    }
    setChipData(chips);
  }, [filters]);

  const handleClearFilters = () => {
    tableContextState?.updateFilters([]); // clear all filters
  };

  const handleDelete = (chipToDelete: ChipData) => () => {
    const updatedFilter = filters?.filter(
      (filter) => filter.name !== chipToDelete.name
    );
    tableContextState?.updateFilters(updatedFilter!);
  };
  if (chipData.length < 1) return <div style={{ marginTop: "10px" }}></div>;
  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "left",
        flexWrap: "wrap",
        listStyle: "none",
        p: 0.5,
        m: 0,
        height: "45px",
      }}
      component="ul"
      className="ChipStackContainer"
    >
      {chipData.map((data) => {
        let icon;

        if (data.label === "React") {
          icon = <TagFacesIcon />;
        }

        return (
          <ListItem key={data.key}>
            <Chip
              icon={icon}
              label={data.label}
              onDelete={data.label === "React" ? undefined : handleDelete(data)}
              className="anyChip font-dfds"
            />
          </ListItem>
        );
      })}
      {chipData.length > 0 ? (
        <Button
          variant="outlined"
          className="clear-filter-button"
          onClick={handleClearFilters}
        >
          Clear Filters
        </Button>
      ) : null}
    </Paper>
  );
}
